module.exports = __webpack_public_path__ + "static/img/263_phase_function_Paper_PointsHejduk_Prediction.2eb2710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/263_phase_function_Paper_PointsHejduk_Prediction.png
// module id = cuFz
// module chunks = 0